import React, { useState } from 'react';
import { SearcherDatepicker } from '@lt/components';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import SearchParamsItem from './SearchParamsItem';
import SearchParamsLabel from './SearchParamsLabel';
import SearchParamsControl from './SearchParamsControl';

import {
  getDateName,
  formatServerDate,
  formatDateToDayShort,
} from '../../../../../utils/dateUtils';

interface SearchParamsDatesProps {
  isMobile?: boolean;
  startDate: string;
  endDate: string;
  onChangeDate: (value: string) => void;
  isHotelOnly: boolean;
  isArchived: boolean;
}

const SearchParamsDates = ({
  isMobile,
  startDate,
  endDate,
  onChangeDate,
  isHotelOnly,
  isArchived,
}: SearchParamsDatesProps) => {
  const { t } = useTranslation();
  const [date, setDate] = useState(new Date(startDate));

  const handleChange = (val: Date) => {
    const serverDate = formatServerDate(val);
    onChangeDate(serverDate);
    setDate(val);
  };

  const CustomControl = isMobile
    ? SearchParamsControlMobile
    : SearchParamsControl;
  const CustomLabel = () => (
    <SearchParamsLabel label={t('checkout.search.dates_package')} />
  );

  return (
    <SearchParamsItem name="dates">
      <div className="flex">
        <div>
          <div className="like-h2 white-space-pre">
            {formatDateToDayShort(startDate)}
            <span className="checkout-shortinfo__dash">—</span>
          </div>
          <span className="capitalize">{getDateName(startDate)}</span>
        </div>
        <div>
          <div className="like-h2">{formatDateToDayShort(endDate)}</div>
          <span className="capitalize">{getDateName(endDate)}</span>
        </div>
      </div>

      {!isArchived && !isHotelOnly ? (
        <StyledWrapper>
          <SearcherDatepicker
            onChangeDate={handleChange}
            selectedDate={date}
            isMobile={isMobile}
            monthsShown={10}
            CustomControl={CustomControl}
            CustomLabel={CustomLabel}
          />
        </StyledWrapper>
      ) : null}
    </SearchParamsItem>
  );
};

const SearchParamsControlMobile = () => {
  const { t } = useTranslation();
  return <StyledButton>{t('checkout.search.dates_package')}</StyledButton>;
};

const StyledWrapper = styled.div`
  position: absolute;
  bottom: -20px;

  .react-select__control {
    height: 17px;
    min-height: 17px;
  }

  .react-select__value-container {
    padding-left: 0;
  }
`;

const StyledButton = styled.div`
  display: flex;
  align-items: center;
  color: #007aff;

  &:hover {
    cursor: pointer;
  }
`;

export default SearchParamsDates;
